var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStoreIcon = function SvgStoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 22.598"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.972 8.157H.002L2.075.814a1.164 1.164 0 0 1 1.149-.816h16.528a1.5 1.5 0 0 1 1.15.816ZM2.309 10.198a2.072 2.072 0 0 0 2.309-2.05H.002a2.191 2.191 0 0 0 2.309 2.05m4.595 0a2.071 2.071 0 0 0 2.309-2.05H4.602a2.19 2.19 0 0 0 2.3 2.05Zm4.6 0a2.071 2.071 0 0 0 2.309-2.05H9.197a2.19 2.19 0 0 0 2.3 2.05Zm4.6 0a2.072 2.072 0 0 0 2.309-2.05h-4.617a2.19 2.19 0 0 0 2.3 2.05Zm4.594 0a2.071 2.071 0 0 0 2.309-2.05h-4.615a2.19 2.19 0 0 0 2.3 2.05Z",
    "data-name": "Path 38"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.602 11.389c-.231 0-.459.205-.921.205a2.017 2.017 0 0 1-2.068-1.23h-.459a2.663 2.663 0 0 1-2.067 1.231 2.192 2.192 0 0 1-2.068-1.4h-.465a2.029 2.029 0 0 1-2.067 1.193 2.039 2.039 0 0 1-2.065-1.193h-.459a2.051 2.051 0 0 1-2.07 1.193 2.038 2.038 0 0 1-2.068-1.193h-.464a2.023 2.023 0 0 1-2.052 1.193 1.921 1.921 0 0 1-.918-.2 3.581 3.581 0 0 1-.256 1.02v8.181a2.191 2.191 0 0 0 2.309 2.05h.954v-8.166h5.733v8.322h9.366a2.192 2.192 0 0 0 2.307-2.035v-8.15a8.858 8.858 0 0 1-.2-1.021m-2.8 7.726h-5.51v-5.097h5.741v5.1Z",
    "data-name": "Path 39"
  })))))));
};
export default SvgStoreIcon;